import { useState } from "react";
import LeadsTable from './LeadsTable';
import SalesLayOut from "../SalesLayOut";

export default function ActiveContacts() {
    const [activeTab, setActiveTab] = useState("wonleads");

    return (
        <SalesLayOut>
            <LeadsTable leadsType="wonleads" setActiveTab={setActiveTab} />
        </SalesLayOut>
    )
}